/**
 * Application entry point that mounts the React app and bootstraps routing.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { ensureAnonymousUser } from './firebase';
import Tracker from '@openreplay/tracker';

const tracker = new Tracker({
  projectKey: "Va3zJ4UhdD87OUrnk3oD",
});
tracker.start()

// Track the referring URL for enriched OpenReplay session metadata.
const referringUrl = document.referrer;
if (referringUrl) {
  tracker.setMetadata('referring_url', referringUrl);
}

/**
 * Ensures an anonymous Firebase user exists so analytics can attribute events.
 */
ensureAnonymousUser()
  .then((user) => {
    if (user?.uid) {
      tracker.setUserID(user.uid);
    }
  })
  .catch((error) => {
    console.error('Anonymous authentication failed to initialize.', error);
  });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
